import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// 선택한 상품이 모두 이미 처리(성공 또는 처리 중)돼 접수할 대상이 없을 때 띄우는 종료 모달.
// 일부만 처리된 경우는 여기 오지 않고, 처리된 상품만 요청에서 제외한 뒤 나머지를 접수한다.
// API 연동과 파일 신청이 함께 쓴다.
function PathPickBasketAlreadyRequestedModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 기본 폭(480px)이 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(480px, 92dvw)"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick:basket.already_requested.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"12px"}>
          <Text textStyle={"body-md-regular"} color={"#1D1D1B"}>
            {t("path_pick:basket.already_requested.body")}
          </Text>
          {/* 확인 버튼만 필요해서 공용 Footer(취소 버튼 고정 노출) 대신 직접 렌더한다. */}
          <Flex justifyContent={"flex-end"}>
            <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
              <Text textStyle={"body-sm-bold"}>
                {t("path_pick:basket.already_requested.confirm")}
              </Text>
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickBasketAlreadyRequestedModal;
